import { useEffect, useState } from 'react'
import { useCartStore } from '~/src/features/cart/stores/useCartStore'
import { useSessionStore } from '~/src/features/account/stores/useSessionStore'

export function useShopBootstrap() {
  const hydrateCart = useCartStore((state) => state.hydrate)
  const hydrateSession = useSessionStore((state) => state.hydrate)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true

    async function bootstrap() {
      try {
        await Promise.all([hydrateSession(), hydrateCart()])
      } finally {
        if (active) {
          setLoading(false)
        }
      }
    }

    bootstrap()

    return () => {
      active = false
    }
  }, [hydrateCart, hydrateSession])

  return { loading }
}
